import { render } from "./QTransportPreloader.vue?vue&type=template&id=564d3ede&scoped=true"
const script = {}

import "./QTransportPreloader.vue?vue&type=style&index=0&id=564d3ede&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend-demo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-564d3ede"]])

export default __exports__